import React, { useState } from 'react';
import { FaEnvelope, FaCheckCircle } from 'react-icons/fa';
import { API_BASE } from '../config';
import { useLanguage } from '../context/LanguageContext';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useLanguage();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    try {
      const res = await fetch(`${API_BASE}/api/newsletter/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, name })
      });

      const data = await res.json();

      if (res.ok) {
        setStatus({ type: 'success', message: 'Successfully subscribed to newsletter!' });
        setEmail('');
        setName('');
      } else {
        setStatus({ type: 'error', message: data.error || 'Failed to subscribe. Please try again.' });
      }
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      setStatus({ type: 'error', message: 'Failed to subscribe. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="section" style={{ background: 'linear-gradient(135deg, var(--primary) 0%, var(--accent-dark) 100%)', padding: '3rem 5%' }}>
      <div style={{ maxWidth: '700px', margin: '0 auto', textAlign: 'center' }}>
        <FaEnvelope style={{ fontSize: '2.5rem', color: 'white', marginBottom: '1rem' }} />
        <h2 style={{ color: 'white', fontSize: '2rem', marginBottom: '0.8rem', fontWeight: '700' }}>
          Subscribe to Newsletter
        </h2>
        <p style={{ color: 'rgba(255,255,255,0.95)', marginBottom: '2rem', fontSize: '1.05rem' }}>
          Get updates on my latest projects and tech insights delivered to your inbox
        </p>

        {status.type === 'success' ? (
          <div style={{
            background: 'rgba(255,255,255,0.2)',
            backdropFilter: 'blur(10px)',
            padding: '1.5rem',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.8rem',
            color: 'white'
          }}>
            <FaCheckCircle style={{ fontSize: '1.5rem' }} />
            <span style={{ fontSize: '1rem', fontWeight: '500' }}>{status.message}</span>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
            <input
              type="text"
              placeholder="Your Name (optional)"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{
                padding: '0.9rem 1.2rem',
                borderRadius: '10px',
                border: 'none',
                fontSize: '0.95rem',
                outline: 'none',
                fontFamily: 'inherit'
              }}
            />
            <div style={{ display: 'flex', gap: '0.8rem', flexWrap: 'wrap' }}>
              <input
                type="email"
                placeholder="Your Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  flex: '1',
                  minWidth: '200px',
                  padding: '0.9rem 1.2rem',
                  borderRadius: '10px',
                  border: 'none',
                  fontSize: '0.95rem',
                  outline: 'none',
                  fontFamily: 'inherit'
                }}
              />
              <button
                type="submit"
                disabled={isSubmitting}
                style={{
                  padding: '0.9rem 2rem',
                  background: 'white',
                  color: 'var(--primary)',
                  border: 'none',
                  borderRadius: '10px',
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  opacity: isSubmitting ? 0.7 : 1,
                  transition: 'var(--transition)',
                  fontFamily: 'inherit'
                }}
                onMouseOver={(e) => {
                  if (!isSubmitting) {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
                  }
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                {isSubmitting ? 'Subscribing...' : 'Subscribe'}
              </button>
            </div>
            {status.type === 'error' && (
              <p style={{ color: '#ffebee', fontSize: '0.9rem', marginTop: '0.3rem' }}>{status.message}</p>
            )}
          </form>
        )}
      </div>
    </section>
  );
};

export default Newsletter;
